<div class="p-6 space-y-6">

  <!-- Card: Ajustes -->
  <div class="bg-white rounded-xl shadow-sm p-6">
    <div class="flex items-center justify-between mb-6">
      <h2 class="text-xl font-bold text-gray-800">Ajustes</h2>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <!-- Rango de fechas -->
      <div class="generador-calendar-wrapper">
        <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
          Rango de días <span class="text-red-500">*</span>
        </label>
        <p-calendar
          [(ngModel)]="dateRange"
          selectionMode="range"
          [showIcon]="true"
          [showOnFocus]="true"
          [readonlyInput]="true"
          [disabledDays]="calendarDisabledDays"
          dateFormat="dd/mm/yy"
          placeholder="Selecciona un rango de fechas"
          inputId="dateRange">
        </p-calendar>
      </div>

      <!-- Días de la semana -->
      <div class="col-span-2">
        <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
          Días de la semana <span class="text-red-500">*</span>
        </label>
        <div class="flex flex-wrap gap-2">
          <button *ngFor="let day of daysOfWeek"
            type="button"
            (click)="toggleDay(day)"
            class="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 border"
            [ngClass]="{
              'bg-red-600 text-white border-red-600 shadow-sm': day.selected,
              'bg-gray-100 text-gray-400 border-dashed border-gray-300 hover:border-gray-400 hover:text-gray-600': !day.selected
            }">
            <svg *ngIf="day.selected" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
            <svg *ngIf="!day.selected" class="w-4 h-4 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
            {{ day.label }}
          </button>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
      <!-- Profesores -->
      <app-custom-multiselect
        label="Profesores"
        [(ngModel)]="teacherIds"
        [options]="teachers"
        optionLabel="name"
        optionValue="id"
        placeholder="Seleccionar profesores"
        [maxSelectedLabels]="2"
        selectedItemsLabel="{0} profesores"
        [required]="true">
      </app-custom-multiselect>

      <!-- Permiso -->
      <app-custom-dropdown
        label="Permiso"
        [(ngModel)]="licenseId"
        [options]="licenses"
        optionLabel="name"
        optionValue="id"
        placeholder="Seleccionar permiso"
        [required]="true">
      </app-custom-dropdown>

      <!-- Sucursal -->
      <app-custom-dropdown
        label="Sucursal"
        [(ngModel)]="officeId"
        [options]="offices"
        optionLabel="name"
        optionValue="id"
        placeholder="Seleccionar sucursal"
        [required]="true">
      </app-custom-dropdown>
    </div>
  </div>

  <!-- Card: Franjas horarias -->
  <div class="bg-white rounded-xl shadow-sm p-6">
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-xl font-bold text-gray-800">Franjas horarias</h2>
    </div>

    <!-- Grupo horario guardado + nombre -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
      <app-custom-dropdown
        label="Cargar grupo horario"
        [(ngModel)]="selectedGroupId"
        [options]="savedGroups"
        optionLabel="name"
        optionValue="id"
        placeholder="Nuevo grupo horario"
        (onChange)="onGroupChange()">
      </app-custom-dropdown>

      <div>
        <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
          Nombre del grupo horario
        </label>
        <input type="text" [(ngModel)]="groupName"
          placeholder="Escribe un nombre para guardar esta configuración"
          class="w-full bg-gray-50 border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition-all">
        <div class="flex items-center gap-2 mt-2">
          <button *ngIf="!selectedGroupId" type="button" (click)="saveGroup()"
            [disabled]="!groupName.trim() || slots.length === 0"
            class="px-3 py-1.5 bg-gray-800 text-white text-xs font-medium rounded-lg hover:bg-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            Guardar grupo
          </button>
          <button *ngIf="selectedGroupId && isGroupModified" type="button" (click)="saveGroup()"
            [disabled]="!groupName.trim() || slots.length === 0"
            class="px-3 py-1.5 bg-gray-800 text-white text-xs font-medium rounded-lg hover:bg-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            Actualizar grupo
          </button>
          <button *ngIf="selectedGroupId" type="button" (click)="deleteGroup()"
            class="px-3 py-1.5 bg-red-100 text-red-700 text-xs font-medium rounded-lg hover:bg-red-200 transition-colors">
            Eliminar grupo
          </button>
        </div>
      </div>
    </div>

    <!-- Configuración rápida -->
    <div class="bg-gray-50 rounded-xl border border-gray-200 p-4 mb-5">
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 items-end">
        <!-- Hora inicio -->
        <div>
          <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Hora inicio</label>
          <input type="time" [(ngModel)]="slotConfig.start_time" (ngModelChange)="generateSlots()"
            class="w-full bg-white border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition-all">
        </div>

        <!-- Hora fin -->
        <div>
          <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Hora fin</label>
          <input type="time" [(ngModel)]="slotConfig.end_time" (ngModelChange)="generateSlots()"
            class="w-full bg-white border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition-all">
        </div>

        <!-- Duración -->
        <app-custom-dropdown
          label="Duración"
          [(ngModel)]="slotConfig.duration"
          [options]="durations"
          optionLabel="label"
          optionValue="value"
          placeholder="Seleccionar"
          [filter]="false"
          [showClear]="false"
          (onChange)="generateSlots()">
        </app-custom-dropdown>

        <!-- Tipo -->
        <app-custom-dropdown
          label="Tipo"
          [(ngModel)]="slotConfig.practice_type"
          [options]="practiceTypes"
          optionLabel="label"
          optionValue="value"
          placeholder="Seleccionar"
          [filter]="false"
          [showClear]="false"
          (onChange)="generateSlots()">
        </app-custom-dropdown>

        <!-- Máx. alumnos -->
        <div>
          <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Máx. alumnos</label>
          <input type="number" [(ngModel)]="slotConfig.max_students" min="1" max="10" (ngModelChange)="generateSlots()"
            class="w-full bg-white border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 text-center focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition-all">
        </div>

        <!-- Vehículo -->
        <div>
          <app-custom-dropdown
            label="Vehículo"
            [(ngModel)]="vehicleId"
            [options]="vehicles"
            optionLabel="model"
            optionValue="id"
            placeholder="Opcional"
            [filterFields]="['model', 'license_plate']">
            <ng-template #itemTemplate let-vehicle>
              <div>{{ vehicle.model }} - {{ vehicle.license_plate }}</div>
            </ng-template>
            <ng-template #selectedItemTemplate let-vehicle>
              <div *ngIf="vehicle">{{ vehicle.model }} - {{ vehicle.license_plate }}</div>
            </ng-template>
          </app-custom-dropdown>
        </div>
      </div>
    </div>

    <!-- Vista previa de franjas generadas -->
    <div *ngIf="slots.length > 0">
      <div class="flex items-center justify-between mb-3">
        <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide">
          {{ slots.length }} franjas generadas
        </label>
      </div>
      <div class="overflow-x-auto rounded-xl border border-gray-200">
        <table class="w-full text-sm">
          <thead>
            <tr class="bg-gray-50 text-left">
              <th class="px-4 py-3 font-semibold text-gray-600">Hora inicio</th>
              <th class="px-4 py-3 font-semibold text-gray-600">Hora fin</th>
              <th class="px-4 py-3 font-semibold text-gray-600">Tipo</th>
              <th class="px-4 py-3 font-semibold text-gray-600 text-center">Máx. alumnos</th>
              <th class="px-4 py-3 font-semibold text-gray-600 text-center w-16"></th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100">
            <tr *ngFor="let slot of slots; let i = index" class="hover:bg-gray-50 transition-colors">
              <td class="px-4 py-2.5 text-gray-800 font-medium">{{ slot.start_time }}</td>
              <td class="px-4 py-2.5 text-gray-700">{{ slot.end_time }}</td>
              <td class="px-4 py-2.5">
                <span class="inline-block px-2.5 py-1 rounded-full text-xs font-medium"
                  [ngClass]="{
                    'bg-green-100 text-green-700': slot.practice_type === 'Abierto',
                    'bg-orange-100 text-orange-700': slot.practice_type === 'Maniobras'
                  }">
                  {{ slot.practice_type }}
                </span>
              </td>
              <td class="px-4 py-2.5 text-gray-700 text-center">{{ slot.max_students }}</td>
              <td class="px-4 py-2.5 text-center">
                <button type="button" (click)="removeSlot(i)"
                  class="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="slots.length === 0" class="text-sm text-gray-400 py-6 text-center">
      Configura la hora de inicio, fin y duración para generar las franjas automáticamente.
    </div>
  </div>

  <!-- Botón Crear prácticas -->
  <div class="flex justify-end">
    <button (click)="generate()"
      [disabled]="loading || !isFormValid()"
      class="px-6 py-3 bg-red-600 text-white text-sm font-semibold rounded-xl hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm hover:shadow-md flex items-center gap-2">
      <svg *ngIf="loading" class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
      {{ loading ? 'Generando...' : 'Crear prácticas' }}
    </button>
  </div>

  <!-- Modal de resultado -->
  <div *ngIf="showResultModal" class="modal-overlay !mt-0 flex items-center justify-center bg-black/40">
    <div class="bg-white rounded-xl shadow-xl p-6 w-full max-w-lg mx-4">
      <div class="flex items-center gap-3 mb-5">
        <div class="flex items-center justify-center w-10 h-10 rounded-full"
          [ngClass]="result?.created > 0 ? 'bg-green-100' : 'bg-red-100'">
          <svg class="w-5 h-5" [ngClass]="result?.created > 0 ? 'text-green-600' : 'text-red-600'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path *ngIf="result?.created > 0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            <path *ngIf="!result?.created || result?.created === 0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
          </svg>
        </div>
        <h3 class="text-lg font-bold text-gray-900">
          {{ result?.created > 0 ? 'Clases creadas correctamente' : 'No se pudieron crear las clases' }}
        </h3>
      </div>

      <!-- Resultado exitoso -->
      <div *ngIf="result?.created > 0" class="mb-5">
        <div class="flex items-center gap-3 bg-green-50 rounded-lg p-4 border border-green-200">
          <span class="inline-flex items-center justify-center w-12 h-12 rounded-full bg-green-100 text-green-700 font-bold text-xl">
            {{ result?.created }}
          </span>
          <span class="text-gray-700 font-medium">clases practicas creadas</span>
        </div>
      </div>

      <!-- Conflictos: no se creó nada -->
      <div *ngIf="result?.conflicts?.length > 0" class="mb-5">
        <p class="text-sm text-gray-600 mb-3">
          Se encontraron conflictos de horarios. No se ha creado ninguna clase. Resuelve los conflictos e intentalo de nuevo.
        </p>
        <div class="max-h-52 overflow-y-auto rounded-lg border border-red-200 bg-red-50 divide-y divide-red-100">
          <div *ngFor="let teacherConflict of result.conflicts" class="px-4 py-3">
            <div class="flex items-center gap-2 mb-2">
              <svg class="w-4 h-4 text-red-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
              </svg>
              <span class="text-sm font-semibold text-red-800">{{ teacherConflict.teacher_name }}</span>
            </div>
            <p class="text-xs text-red-600 mb-1.5">Tiene conflictos con sus horarios en los siguientes dias:</p>
            <div class="flex flex-wrap gap-1.5">
              <span *ngFor="let date of teacherConflict.dates"
                class="inline-block px-2 py-0.5 bg-red-100 text-red-700 text-xs font-medium rounded">
                {{ date }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-end gap-3 pt-3 border-t border-gray-100">
        <button (click)="closeResultModal()"
          class="px-4 py-2.5 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors">
          {{ result?.conflicts?.length > 0 ? 'Cerrar' : 'Generar mas clases' }}
        </button>
        <button *ngIf="result?.created > 0" (click)="goToCuadrante()"
          class="px-4 py-2.5 bg-red-600 text-white text-sm font-medium rounded-lg hover:bg-red-700 transition-colors">
          Ver en cuadrante
        </button>
      </div>
    </div>
  </div>

  <!-- Modal confirmación eliminar grupo -->
  <div *ngIf="showDeleteGroupConfirm" class="modal-overlay !mt-0 flex items-center justify-center bg-black/40">
    <div class="bg-white rounded-xl shadow-xl p-6 w-full max-w-sm mx-4">
      <div class="flex items-center gap-3 mb-4">
        <div class="flex items-center justify-center w-10 h-10 rounded-full bg-red-100">
          <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
          </svg>
        </div>
        <h3 class="text-lg font-bold text-gray-900">Eliminar grupo horario</h3>
      </div>
      <p class="text-sm text-gray-600 mb-5">
        Se eliminara el grupo horario <strong>{{ groupName }}</strong>. Esta accion no se puede deshacer.
      </p>
      <div class="flex items-center justify-end gap-3">
        <button (click)="showDeleteGroupConfirm = false"
          class="px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors">
          Cancelar
        </button>
        <button (click)="confirmDeleteGroup()"
          class="px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-lg hover:bg-red-700 transition-colors">
          Eliminar
        </button>
      </div>
    </div>
  </div>

</div>
